.form-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem 1rem;
}

.form-field--outerspace {
  margin: 1.5rem 0;
}

.form-field--inline {
  align-items: center;
  flex-direction: row;
}

.form-field--align-start {
  align-items: flex-start;
}
